export default function Avatar({ src, size = 24, className = '', title = '' }) {
  const isUrl = src?.startsWith('http');
  return (
    <div
      className={`rounded-full flex items-center justify-center overflow-hidden flex-shrink-0 ${className} bg-zinc-100`}
      style={{ width: size, height: size }}
      title={title}
    >
      {isUrl ? (
        <img src={src} alt="avatar" className="w-full h-full object-cover" />
      ) : (
        <span style={{ fontSize: `${size * 0.6}px` }}>{src || '👤'}</span>
      )}
    </div>
  );
}
